RivalIQ.module('export.models.factories', function (factories, App, Backbone, Marionette, $, _) {

    'use strict';

    factories.csv = function (model) {
        const dashboardModel = model.config;

        const csvModel = dashboardModel.getPropsForFormat(RivalIQ.enums.exportFormat.CSV);
        model.set({
            landscapeId: RivalIQ.state.view.get('landscapeId'),
            slides: [csvModel]
        }, {
            silent: true
        });
    };

});
